module.exports = __webpack_public_path__ + "static/specialists-slideshow-04-69a6035395ced9fdd2662390f71c2245.jpg";